import React, { ReactNode } from 'react';
import { SelectorValue } from 'src/components/Flowsteps/base/FilterManager';
import { isSubstitutionPattern } from "shared/utils/querySubstitution";
import {
    RangeValueEditor
} from 'src/v2/components/controls/FilterManager/value-editors/RangeValueEditor/RangeValueEditor';
import { DataField } from 'shared/providers/types';
import { HubspotFieldEditorProps } from './types';
import {
    DateTimeEditor,
    DefaultEditor,
    FieldControlProps
} from "@v2/components/flowsteps/editors/common/filter-editors";

export const OptionsSelector: React.FC<FieldControlProps> = ({ value, onChange, field, operator }) => {
    const options = field?.options || [];
    const isSubstitution = isSubstitutionPattern(value);

    return (
      <SelectorValue
        isSubstitution={isSubstitution}
        options={options.map(option => ({
            key: option.value,
            text: option.label,
        }))}
        plural={operator === 'IN'}
        value={value}
        onChange={onChange}
      />
    )
}

const typeEditorMap: Record<string, React.FC<any> | undefined> = {
    'datetime': DateTimeEditor,
    'date': DateTimeEditor,
    'string': DefaultEditor,
    'enumeration': OptionsSelector,
}

export const renderEditorForTypeAndOperator = (field: DataField, operator: string, props: HubspotFieldEditorProps): ReactNode => {
    const Editor = typeEditorMap[field.type] || DefaultEditor;
    if (operator === 'BETWEEN') {
        return <RangeValueEditor EditorComponent={Editor} {...props} />
    }
    return <Editor field={field} operator={operator} {...props} />;
}

export const renderEditorForType = (field: DataField, props: HubspotFieldEditorProps): ReactNode => {
    const Editor = typeEditorMap[field.type] || DefaultEditor;
    return <Editor disableMultiply={true} {...props} />;
}
